import React from 'react';
import styled from "styled-components";
import CurrencyFormatter from "../../../Components/Commons/CurrencyFormatter.react";

const StyledBreakdown = styled.div`
  background-color: white;
  color: #575757;
  height: 28rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 3rem;
  
  .transaction-type {
    padding-left: 3rem;
    padding-top: 1.5rem;
    
    .date {
      font-size: 2rem;
      color: #8B8B8B;
      letter-spacing: 1px;
    }
    
    .type {
      line-height: 110%;
      font-size: 3rem;
    }
  }
  
  .transaction-breakdown {
    padding-bottom: 1.3rem;
    padding-left: 2rem;
    font-size: 4rem;
    letter-spacing: 3px;
  }
  
  .transaction-stats {
    display: flex;
    
    .stat {
      border-right: 1px solid #575757;
      border-top: 1px solid #575757;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 10rem;
      width: 22rem;
      
      .amount {
        font-size: 2.5rem;
        text-align: right;
        font-family: monospace;
      }
    }
  }
`

const deriveUsdVolume = (transaction) => {
  if(transaction.lines){
    return transaction.lines
        .filter(x => x.lineType === 'credit')
        .reduce((r,x) => {
            return r + x.journalAssetQuantity.quantity
        }, 0)
  }
}
const getUsdVolumne = (transaction) => {
  const {prices} = transaction
  const price = prices ? prices[0]: undefined
  if(price) {
      return price?.quantity
  } else {
      return deriveUsdVolume(transaction)
  }
}

const Breakdown = ({transaction}) => {
  return (
    <StyledBreakdown>
      <div className={'transaction-type'}>
        <p className={'type'}>
          {transaction.type}
        </p>
        <p className={'date'}>
          {transaction.datetime}
        </p>
      </div>
      <div>
        <div className={'transaction-breakdown'}>
          {/*"$10,150 USD > 1 BTC"*/}
        </div>
        <div className={'transaction-stats'}>
          <div className={'stat'}>
            <p className={'amount'}>
              {<CurrencyFormatter type={'FIAT'} quantity={getUsdVolumne(transaction)} symbol={'$'} />}
            </p>
            <p>USD Volume</p>
          </div>
          {/*<div className={'stat'}>
            <p className={'amount'}>
              {`0.00073254 BTC`}
            </p>
            <p>
              {transaction.type === "MARGIN" ? `Expense` : `Fee Revenue`}
              Fee Expense
            </p>
          </div>*/}
        </div>
      </div>
    </StyledBreakdown>
  )
}

export default Breakdown;